import AbstractScene from './AbstractScene.js';
import UI from './UI.js';

export default class Preloader extends AbstractScene {

    constructor() {
        super({
            key: "Preloader"
        })
    }
    init(data) {
        this._init(data);
    }

    preload() {
        this._preload();

        // Ajout du texte de chargement
        this.loadingText = this.make.text({
            x: this.width / 2,
            y: this.height / 2,
            text: 'Chargement... 0%',
            style: {
                font: '60px CardenioBold',
                fill: '#000000',
                stroke: '#FFF',
                strokeThickness: 8
            }
        });

        this.loadingText.setOrigin(0.5, 0.5);

        this.loadSprites();

        this.load.on('progress', (value) => {
            // this.chargement.setScale(value, 1);
            this.loadingText.text = 'Chargement... ' + Math.floor(value * 100) + '%';
        });
        
        // this.load.on('fileprogress', function (file) {
            // console.log(file.src);
        // });

        this.load.on('complete', function () {
            this.scene.add('UI', UI, true);
            this.nextScene();
        }, this);
    }

    loadSprites() { 
        this.load.html('videoPlayer', 'assets/videos/video.html');
        this.load.json('config', 'assets/config.json');

        this.load.image('intro', "assets/images/menu/image_menu.png")
        this.load.image('mqde', "assets/images/menu/mqde.png")
        this.load.image('rectIntro', "assets/images/menu/rect_menu.png")
        this.load.image('logoABC', "assets/images/menu/logo_abc.png")
        this.load.image('logoMQDE', "assets/images/menu/logo_mqde_couleur.png")
        this.load.image('logoBDF', "assets/images/menu/logo_bdf.png")
        this.load.image('logoSydo', "assets/images/menu/logo_sydo.png")
        this.load.image('backFin', 'assets/images/menu/back_fin.png')
        this.load.image('backLine', 'assets/images/menu/back_line.png')
        this.load.image('logoLinkedin', 'assets/images/menu/logo_linkedin.png')

        this.load.image('icon_correct', 'assets/images/icon_correct.png')
        this.load.image('icon_false', 'assets/images/icon_false.png')
        this.load.image('icon_correct_blanc', 'assets/images/icon_correct_blanc.png')
        this.load.image('icon_false_blanc', 'assets/images/icon_false_blanc.png')

        // --- Game 1 ---
        this.load.image('background_0', 'assets/images/game1/background_0.png')
        this.load.image('info', 'assets/images/game1/info.png')

        this.load.image('zone1', 'assets/images/game1/zone.png')
        this.load.image('zone1_false', 'assets/images/game1/zone_false.png')
        this.load.image('zone1_over', 'assets/images/game1/zone_over.png')

        this.load.image('profitabilite', 'assets/images/game1/profitabilite.png')
        this.load.image('profitabilite_ok', 'assets/images/game1/profitabilite_ok.png')
        this.load.image('profitabilite_true', 'assets/images/game1/profitabilite_true.png')

        this.load.image('solvabilite', 'assets/images/game1/solvabilite.png')
        this.load.image('solvabilite_ok', 'assets/images/game1/solvabilite_ok.png')
        this.load.image('solvabilite_true', 'assets/images/game1/solvabilite_true.png')
        this.load.image('solvabilite_info', 'assets/images/game1/solvabilite_info.png')

        this.load.image('liquidite', 'assets/images/game1/liquidite.png')
        this.load.image('liquidite_ok', 'assets/images/game1/liquidite_ok.png')
        this.load.image('liquidite_true', 'assets/images/game1/liquidite_true.png')
        this.load.image('liquidite_info', 'assets/images/game1/liquidite_info.png')

        this.load.image('independance', 'assets/images/game1/independance.png')
        this.load.image('independance_ok', 'assets/images/game1/independance_ok.png')
        this.load.image('independance_true', 'assets/images/game1/independance_true.png')
        this.load.image('independance_info', 'assets/images/game1/independance_info.png')

        this.load.image('capacite', 'assets/images/game1/capacite.png')
        this.load.image('capacite_ok', 'assets/images/game1/capacite_ok.png')
        this.load.image('capacite_true', 'assets/images/game1/capacite_true.png')
        this.load.image('capacite_info', 'assets/images/game1/capacite_info.png')

        // --- Game 2 ---
        this.load.image('background_1', 'assets/images/game2/background_1.png')

        this.load.image('zone2', 'assets/images/game2/zone.png')
        this.load.image('zone2_false', 'assets/images/game2/zone_false.png')
        this.load.image('zone2_over', 'assets/images/game2/zone_over.png')

        this.load.image('card2', 'assets/images/game2/card.png')
        this.load.image('card2_false', 'assets/images/game2/card_false.png')
        this.load.image('card2_true', 'assets/images/game2/card_true.png')
        this.load.image('card2_small', 'assets/images/game2/card_small.png')

    }
}